module.exports = __webpack_public_path__ + "img/C101.d92ca58c.png";